/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
        console('here', to.hash);
        return {selector: to.hash}
        //Or for Vue 3:
        //return {el: to.hash}
    } else {
        return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/eligibility',
      name: 'eligibility',

      component: () => import( './views/Eligibility.vue')
    },
    {
      path: '/eligible',
      name: 'eligible',

      component: () => import( './views/Eligible.vue')
    },
    {
      path: '/provider-search',
      name: 'provider_search',

      component: () => import( './views/ProviderSearch.vue')
    },
    {
      path: '/apply',
      name: 'apply',

      component: () => import( './views/Apply.vue')
    },
    {
      path: '/programs',
      name: 'programs',

      component: () => import('./views/Programs.vue')
    },
    {
      path: '/programs/sc-first-steps',
      name: 'first_steps',

      component: () => import('./views/SCFirstSteps.vue')
    },
    {
      path: '/programs/head-start',
      name: 'head_start',

      component: () => import('./views/HeadStart.vue')
    },
    {
      path: '/programs/public-school-prek',
      name: 'public_school',

      component: () => import('./views/PublicSchool.vue')
    },
    {
      path: '/programs/sc-vouchers',
      redirect: { name: 'sc_vouchers' }
    },
    {
      path: '/programs/child-care-scholarships',
      name: 'sc_vouchers',

      component: () => import('./views/SCVouchers.vue')
    },
    {
      path: '/about',
      name: 'about',

      component: () => import('./views/About.vue')
    },
    {
      path: '*',
      name: '404',

      component: () => import('./views/404.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',

      component: () => import('./views/PrivacyPolicy.vue')
    },
    {
      path:'/request-speaker',
      name: 'request_speaker',
      
      component: () => import('./views/RequestSpeaker.vue')
    },
    {
      path: '/voucher-eligible',
      name: 'voucher_eligible',

      component: () => import('./views/VoucherEligible.vue')
    },
    {
      path:'/accessibility',
      name: 'accessibility',

      component:() => import('./views/Accessibility.vue')
    },
    {
      path:'/parent-resources',
      name: 'parent-resources',

      component:() => import('./views/ParentResources.vue')
    }
  ]
})


export default router

router.beforeEach((to, from, next) => {
  //window.scrollTo(0, 0)
  next();
})